import { render, staticRenderFns } from "./CrispLiveChat.vue?vue&type=template&id=0246011a&"
import script from "./CrispLiveChat.vue?vue&type=script&lang=ts&"
export * from "./CrispLiveChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports